export default __webpack_public_path__ + "static/media/minvivienda.bc998169.png";